import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from "@angular/router";
import { 
        GetPrivateMembersGroups,
        DeletePrivateMemberGroup
       } from '../store/private-member.action';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { AddMemberGroupComponent } from "../add-member-group/add-member-group.component";
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-member-grp-list',
  templateUrl: './member-grp-list.component.html',
  styleUrls: ['./member-grp-list.component.scss']
})
export class MemberGrpListComponent implements OnInit {
  displayedColumns = ["group-name", "description", "members", "edit"];
  privateMemberGroups$;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationsService
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetPrivateMembersGroups());
    // this. privateMemberGroups$ = this.store.select(state => state.privateMember.privateMemberGroups).subscribe(
    //   res => {
    //     console.log(res)
    //     return res;
    //   }
    // );
    this. privateMemberGroups$ = this.store.select(state => state.privateMember.privateMemberGroups);
  }

  // goToAddGroup() {
  //   const dialogRef = this.dialog.open(AddMemberGroupComponent, {
  //     width: "60%"
  //   });
  //   dialogRef
  //     .afterClosed()
  //     .subscribe(result => console.log("dialog closed", result));
  // }


  goToAddGroup() {
    
    // this.commonService.NewUserButtonClicked =true;
    const dialogRef = this.dialog.open(AddMemberGroupComponent, {
      width: "60%",
      panelClass:"cmp-modal",
    });
    dialogRef
      .afterClosed()
      .subscribe(result => {

        // dialogRef.close('Pizza!');

        if(result && result.type === 'createGroup') {
          this.notificationService.success('Private member list created successfully');
          this.store.dispatch(new GetPrivateMembersGroups());
        }
      });
  }



  goToGroupDetail(group) {
    this.router.navigate([group._id], { relativeTo: this.activatedRoute });
  }

  removeConfirmation(groupId) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "500px",
      panelClass:'cmp-modal',
      data: {
        text: "Are you sure you want to delete this private member list?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(new DeletePrivateMemberGroup(groupId));
      }
    });
  }



}
